const initialState = { allAnnouncements: [], visibleAnnouncements: [] }

export default initialState
